import React from 'react'
import Todo from './Components/Todo'
import './App.css'

const App = () => {
  return (
    <>
      <Todo />
    </>
  )
}

export default App
